import { Link } from "@reach/router";
import React from "react";
import styled from "styled-components";

const Layout = ({ children }: any) => {
  return <div>
      <Link to={"/"}>
          <Button>
              <div> الرئيسية</div>
          
          <Icon src="https://www.svgrepo.com/show/14443/home.svg" />
          </Button>
          </Link>
      
      {children}</div>;
};

const Icon = styled.img`
width:20px;
margin:10px;
filter:invert(100%);
`


const Button = styled.div`
display: flex;
justify-content:center;
align-items:center;
font-size:1.1em;
font-weight:bold;
`
export default Layout;
